Greenmile.Tag = Greenmile.Tag || {};

Greenmile.Tag.FiltersField = (function () {
  function FiltersField() {

    Monet.UI.Fields.Base.apply(this, arguments);

    this.filters = [];
    this.currentId = 0;
    this.placeholderSelectAnInformation = "";
    this.placeholderInsertValue = "";
    this.enableRequiredInOperatorInput = false;
    this.createBaseStructure();

    this.clear = () => {
      this.filters = [];
      this.currentId = 0;
      const filterContainers = document.querySelectorAll('#Tag #filtersField .filterContainer');
      filterContainers.forEach((filterContainer) => {
        this.removeFilter(filterContainer);
      });
    };

    this.validate = () => {
      let isValid = true;
      let errors = [];

      if (this.getValue() !== '{"criteriaChain":[{"and":[]}]}') {
        this.filters.forEach((filter) => {
          for (const key in filter) {
            if (key !== 'id') {
              if (!filter[key].getValue()) {
                filter[key].rootEl.classList.add('control-group', 'error');
                isValid = false;
              } else {
                filter[key].rootEl.classList.remove('control-group', 'error');
              }
            }
          }
        });
      }

      if (!isValid) {
        errors.push(Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey('error.restrictionInvalid')));
      }

      return errors;
    };

    this.setValue = (values) => {
      const jsonParameter = JSON.parse(values);

      if (jsonParameter.criteriaChain[0].and && jsonParameter.criteriaChain[0].and.length > 0) {
        this.clear();

        const attributesSelected = jsonParameter.criteriaChain[0].and;
        attributesSelected.forEach((attributeSelected) => {
          const dataType = this.getDataType(this.getAttributeType(attributeSelected.attr));
          const arrayOperator = Greenmile.Utils.getOperators(dataType);
          for (let i = 0; i < arrayOperator.length; i++) {
            if (attributeSelected[arrayOperator[i].value]) {
              let operator = arrayOperator[i].value;
              if (attributeSelected.matchMode === 'ANYWHERE') {
                operator = 'contains';
              }
              this.createElement({
                attribute: attributeSelected.attr,
                operator,
                value: attributeSelected[arrayOperator[i].value]
              });
            }
          }
        });
      }
    };

    this.getValue = () => {
      const jsonParameter = {};
      jsonParameter.criteriaChain = [
        { 'and': [] }
      ];

      this.filters.forEach((filter) => {
        let value = filter.valueField.getValue();
        
        const criteriaObject = {
          attr: filter.attributeField.getValue()
        };
  
        let operator = filter.operatorField.getValue();
  
        if (operator === 'contains') {
          operator = 'eq';
          criteriaObject.matchMode = "ANYWHERE";
        }
        
        if(operator === 'in') {
          value = value.trim().split(/\s*,\s*/);
        }
  
        criteriaObject[operator] = value;

        if (criteriaObject.attr) {
          jsonParameter.criteriaChain[0].and.push(criteriaObject);
        }

      });
      
      return JSON.stringify(jsonParameter);
    };

    this.getFilterById = (filterId) => {
      for (let i = 0; i < this.filters.length; i++) {
        if (this.filters[i].id === filterId) {
          return this.filters[i];
        }
      }
    };

    this.setFilterById = (filterId, filter) => {
      for (let i = 0; i < this.filters.length; i++) {
        if (this.filters[i].id === filterId) {
          this.filters[i] = filter;
        }
      }
    };

    this.getAllFilters = () => {
      return this.filters;
    };

    this.addFilter = (filter) => {
      this.filters.push(filter);
    };

    this.removeFilter = (filterContainer, filterId) => {
      const parent = filterContainer.parentNode;
      if (parent) {
        parent.removeChild(filterContainer);
      }
      if (filterId) {
        for (let i = 0; i < this.filters.length; i++) {
          if (this.filters[i].id === filterId) {
            this.filters.splice(i);
            return;
          }
        }
      }
    };

    this.getNextId = function () {
      return this.currentId++;
    };

    this.getAttributeType = function (key) {
      const attributes = Greenmile.Tag.AutoCompleteTags.possibleRestrictions;

      for (let i = 0; i < attributes.length; i++) {
        if (attributes[i].text === key) {
          return attributes[i].type;
        }
      }
    };

    this.getDataType = function (attributeType) {
      return attributeType === 'TextField' ? 'text' : attributeType === 'Checkbox' ? 'checkbox' : 'number';
    };

    this.changeFieldType = (filterId, valueFieldContainer, oldAttributeValue, newAttributeValue) => {
      const filter = this.getFilterById(filterId);
      if (filter) {
        const oldType = this.getAttributeType(oldAttributeValue);
        const newType = this.getAttributeType(newAttributeValue);
        if (newType !== oldType) {
          filter.valueField = this.createValueField(newType, valueFieldContainer, filter.operatorField);
          this.setFilterById(filterId, filter);
        }
      }
    };

    this.createValueField = (attributeType, valueFieldContainer, operatorField) => {
      // Create and append new value field
      const valueField = new Monet.UI.Fields[attributeType]();
      valueField.rootEl.className = 'valueField';
      valueFieldContainer.innerHTML = '';
      valueFieldContainer.appendChild(valueField.render());

      // Set right operators list for this field type
      operatorField.setData(Greenmile.Utils.getOperators(this.getDataType(attributeType)));
      operatorField.setSelectedValue('');

      return valueField;
    };

    this.createLabel = (innerText) => {
      const label = document.createElement("label");
      label.style.marginLeft = "-3em";
      label.innerHTML = innerText;
      return label;
    }

    this.setPlacehoderSelectAnInformation = (text) => {
      this.placeholderSelectAnInformation = text;
    }

    this.setPlaceholderInsertValue = (text) => {
      this.placeholderInsertValue = text;
    }

    this.setRequiredToOperatorInput = () => {
      this.enableRequiredInOperatorInput = true;
    }

    this.createElement = function (filterValues = {}) {
      const { attribute, operator, value } = filterValues;
      const filterId = 'containerRestrictionTag' + this.getNextId();
      const attributeType = attribute ? this.getAttributeType(attribute) : 'TextField';
      const filterContainer = document.createElement("div");
      
      filterContainer.setAttribute("class", "filterContainer shouldAnimate");
      setTimeout(() => filterContainer.classList.remove('shouldAnimate'), 500);
      filterContainer.setAttribute("id", filterId);
      this.currentId > 1 && filterContainer.appendChild(this.createLabel(
        Monet.I18n.getResourcesByKey('tag.label.condition.and')
      ));
      
      // Create attribute field
      const attributeField = new Monet.UI.Fields.PickListAutoComplete();
      attributeField.setResourcePrefix('SelectKeyResource');
      attributeField.setFieldDomains(Greenmile.Tag.AutoCompleteTags.possibleRestrictions);
      this.placeholderSelectAnInformation !== "" && attributeField.setDefaultOption(
        this.placeholderSelectAnInformation
      );
      filterContainer.appendChild(attributeField.render());
      attribute && attributeField.setValue(attribute);

      const spanElement = attributeField.rootEl.children[1].children[0].children[0].children[0];
      spanElement.style.textTransform = "none";
      spanElement.style.color = "#000";

      if(spanElement.innerHTML === "") {
        spanElement.innerHTML = this.placeholderSelectAnInformation;
        spanElement.style.color = "#1A2127";
      }
      
      // Create operator field
      const operatorField = new Monet.UI.Fields.PickList();
      operatorField.createElement();
      operatorField.setData(Greenmile.Utils.getOperators());
      operatorField.setId('restrictionOperator');
      operatorField.input.setAttribute('class', 'operator');
      this.enableRequiredInOperatorInput && operatorField.input.setAttribute('required', true);
      operatorField.rootEl.className = 'divRestriction';
      operator && operatorField.setSelectedValue(operator);
      filterContainer.appendChild(operatorField.rootEl);

      // Create value field
      const valueFieldContainer = document.createElement("div");
      valueFieldContainer.className = 'valueFieldContainer';

      const valueField = this.createValueField(attributeType, valueFieldContainer, operatorField);
      value && valueField.setValue(value);
      filterContainer.appendChild(valueFieldContainer);
      valueField.input.placeholder = this.placeholderInsertValue;

      // Create add/remove buttons
      const buttonsContainer = document.createElement("div");
      buttonsContainer.className = 'buttonsContainer';
      
      const buttonAdd = document.createElement("div");
      buttonAdd.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey("ipRangeProfile.plus"));
      buttonAdd.setAttribute("class", "buttonAdd");

      const buttonRemove = document.createElement("div");
      buttonRemove.setAttribute("class", "buttonRemove");
      buttonRemove.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey("ipRangeProfile.remove"));
      this.currentId > 1 && buttonsContainer.appendChild(buttonRemove);
      buttonsContainer.appendChild(buttonAdd);
      filterContainer.appendChild(buttonsContainer);

      // Add event listeners
      buttonAdd.addEventListener('click', () => {
        this.createElement();
      });

      buttonRemove.addEventListener('click', () => {
        this.removeFilter(filterContainer, filterId);
      });

      attributeField.onSelect = (oldValue, newValue) => {
        this.changeFieldType(filterId, valueFieldContainer, oldValue, newValue);
      };

      // Set root element
      this.rootEl.setAttribute('id', 'filtersField');
      this.rootEl.appendChild(filterContainer);

      this.addFilter({ attributeField, operatorField, valueField, id: filterId });
    };

    this.render = function () {
      this.createElement();
      return this.rootEl;
    };

  }

  return FiltersField;

}());
